import {
    SET_LIST_CONFIRM_MONETIZATION,
    SET_EMAIL_SEND_MONETIZATION,
    SET_START_LIST_MONETIZATION,
    SET_LOADING_MONETIZATIONS,
    SET_CONFIRM_MONETIZATION,
    SET_LIST_MONETIZATION,
    SET_LIST_REPORTS,
    SET_JOB_STATUS,
} from "@/views/reports/store/types/types.js";

const mutations = {
    [SET_LIST_CONFIRM_MONETIZATION] : (state, payload) => state.sendListConfirmMonetization = payload,
    [SET_START_LIST_MONETIZATION]: (state, payload) => state.listStartMonetization = payload,
    [SET_CONFIRM_MONETIZATION]: (state, payload) => state.postConfirmMonetization = payload,
    [SET_LOADING_MONETIZATIONS]: (state, payload) => state.loadingConfirm = payload,
    [SET_LIST_MONETIZATION]: (state, payload) => state.monetizationList = payload,
    [SET_EMAIL_SEND_MONETIZATION] : (state, payload) => state.emailSend = payload,
    [SET_LIST_REPORTS]: (state, payload) => state.reports = payload,
    [SET_JOB_STATUS]: (state, payload) => state.jobStatus = payload
};

export default mutations